import { Group, Indicator } from '@mantine/core';
import {
  IconCalendarEvent,
  IconDotsCircleHorizontal,
  IconFiles,
  IconInbox,
  IconLayoutSidebarRightCollapse,
  IconX,
} from '@tabler/icons';
import { FC, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useNavigationItem } from '../../../Organismns/Navigation/NavigationItemHook';
import { PostboxCountersContext } from '../../../Service/Context/PostboxCountersContext';
import ActionIconWithText from './ActionIconWithText';

interface HandlersProps {
  openNavBar: () => void;
  toggleAsideBar: () => void;
  asideBarOpen: boolean;
}

const EventDetailsFooter: FC<HandlersProps> = ({ openNavBar, toggleAsideBar, asideBarOpen }) => {
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const { unreadCount } = useContext(PostboxCountersContext);

  // eslint-disable-next-line no-underscore-dangle
  const _navigate = (pathname: string) => {
    if (asideBarOpen) {
      toggleAsideBar();
    }
    navigate(pathname);
  };

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText label="Alle" onClick={openNavBar}>
        <IconLayoutSidebarRightCollapse />
      </ActionIconWithText>
      <ActionIconWithText
        label="Details"
        active={useNavigationItem(`/events/${eventId}/details`)}
        onClick={() => _navigate(`/events/${eventId}/details`)}
      >
        <IconCalendarEvent />
      </ActionIconWithText>
      <ActionIconWithText
        label="Dateien"
        active={useNavigationItem(`/events/${eventId}/documents`)}
        onClick={() => _navigate(`/events/${eventId}/documents`)}
      >
        <IconFiles />
      </ActionIconWithText>
      <Indicator color="red" label={unreadCount} radius="xl" size={20} disabled={!unreadCount || unreadCount === 0}>
        <ActionIconWithText
          label="Mails"
          active={useNavigationItem(`/events/${eventId}/emails`)}
          onClick={() => _navigate(`/events/${eventId}/emails/inbox`)}
        >
          <IconInbox />
        </ActionIconWithText>
      </Indicator>
      <ActionIconWithText label={asideBarOpen ? '' : 'Mehr'} onClick={toggleAsideBar}>
        {asideBarOpen ? <IconX /> : <IconDotsCircleHorizontal />}
      </ActionIconWithText>
    </Group>
  );
};

export default EventDetailsFooter;
